export const LANGUAGE = {
    ENG: 'eng',
    SPA: 'spa',
};

export const SUPPORTED_LANGUAGES = [LANGUAGE.ENG, LANGUAGE.SPA];
